import getComponentById from './get-component-by-id';

export default {
  getComponentById,
};
